import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { primaryApi } from '../../utilities/apiEndpointUtility';
import { failureMessage } from '../Notifications/notificationsSlice';

import {
	getMetrics,
	getMetricsCompleted,
	getMetricsFailed
} from './metricsSlice';

export const getMetricsEpic = (action$, state$) =>
	action$.pipe(
		ofType(getMetrics.type),
		mergeMap(async (action) => {
			try {
				const metrics = await axios.get(`${primaryApi()}/api/v1/metrics`);

				return metrics.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getMetricsCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(getMetricsFailed(error.message), failureMessage(error.message)),
				source
			);
		})
	);

export default [getMetricsEpic];
